import React from 'react'
import "./FamilyRetreats.css"
import { openBooking } from '../../app/utils/links'

function FamilyRetreats() {
  return (
    <>
      <section className="family-hero banner_sec">
        <div className="container ">
          <div className='banner-wraper'>
            <h1 className="banner-heading">Slow Holidays. <span>Shared Moments.</span></h1>
            <p className="banner-sub-heading">Slow Holidays. Shared Moments.</p>
            <p className="content text-white mb-4">
              Designed for families and mindful travellers, our journeys offer a balance of exploration and rest. Whether it’s a short forest escape or a multi-day immersion, each itinerary includes guided experiences, local interactions, and time to simply be. These are holidays where connections with nature, with people, and with each other take centre stage.
            </p>
            {/* <button className="primary_btn">View Journeys</button> */}
          </div>
        </div>
      </section>

      {/* Section 1: 1N / 2D Forest Sampler */}
      <section className="section-padding" id="journeys" style={{ scrollMarginTop: "110px" }}>
        <div className="container">
          <div className="row g-0 align-items-start journey-row bg-color">
            <div className="col-md-6">
              <div className="">
                <img loading="lazy" decoding="async"
                  src={require("../../app/assets/images/forest-sampler.webp")}
                  alt="Forest Sampler"
                  className="journey-img"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="journey-content-box">
                <h2 className="heading">Forest Sampler</h2>
                <p className="sub-heading mb-4"><i>(1 night & 2 days)</i></p>
                <p className="content">
                  <strong>Overview:</strong> A short and refreshing forest escape designed to slow you down and help you experience the rhythm of Camp Hornbill.<br />
                  deal for first-time visitors and relaxed weekend stays.
                </p>
                <p className="content">
                  <strong>Highlights:</strong> Nature walks • Riverside time • Forest stay experience • Open green spaces
                </p>
                <p className="content">
                  <strong>What to Wear:</strong> Muted colours, comfortable walking shoes, and season-appropriate outdoor clothing
                </p>
                <p className="content">
                  <strong>Best For:</strong> Families • Couples • Weekend escapes • Slow travelers
                </p>
                <p className="content">
                  <strong>Seasonal Forest Mood:</strong> Cool winter mornings, shaded summer afternoons, and lush monsoon landscapes throughout the year
                </p>
                <p className='content'>Sometimes the forest doesn’t need an itinerary - only your presence.</p>
                <button className="primary_btn mt-4" onClick={openBooking}>Plan This Journey</button>
              </div>
            </div>
          </div>
          <div className="row g-0 align-items-start journey-row bg-color flex-md-row-reverse">
            <div className="col-md-6">
              <div className="">
                <img loading="lazy" decoding="async"
                  src={require("../../app/assets/images/roots&woods.webp")}
                  alt="Forest Sampler"
                  className="journey-img"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="journey-content-box">
                <h2 className="heading">Roots & Woods</h2>
                <p className="sub-heading mb-4"><i>(2 nights & 3 days)</i></p>
                <p className="content">
                  <strong>Overview:</strong> A balanced retreat blending forest experiences, village interactions, hands-on learning, and slow moments in nature.<br />
                  Designed for guests who want to explore beyond the stay while still keeping time to relax and reconnect.
                </p>
                <p className="content">
                  <strong>Highlights:</strong> Village experience • Nature walks • Riverside time • Local interactions • Relaxed Forest evenings
                </p>
                <p className="content">
                  <strong>What to Wear:</strong> Muted colours, comfortable walking shoes, and season-appropriate outdoor clothing
                </p>
                <p className="content">
                  <strong>Best For:</strong> Families • Couples • Small groups • Slow travelers
                </p>
                <p className="content">
                  <strong>Experience Style:</strong> Balanced activity with a mix of exploration, learning, and downtime
                </p>
                <p className="content">
                  <strong>Seasonal Forest Mood:</strong> Cool winter mornings, refreshing summer river experiences, and lush green monsoon landscapes throughout the year
                </p>
                <p className='content'>Travel slowly enough, and every forest begins to feel like home.</p>
                <button className="primary_btn mt-4" onClick={openBooking}>Plan This Journey</button>
              </div>
            </div>
          </div>
          <div className="row g-0 align-items-start journey-row bg-color">
            <div className="col-md-6">
              <div className="">
                <img loading="lazy" decoding="async"
                  src={require("../../app/assets/images/call-wild.webp")}
                  alt="Forest Sampler"
                  className="journey-img"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="journey-content-box">
                <h2 className="heading">Call of the Wild</h2>
                <p className="sub-heading mb-4"><i>(2 nights & 3 days)</i></p>
                <p className="content">
                  <strong>Overview:</strong> A balanced forest retreat combining wildlife safari, riverside experiences, nature walks, and slow moments in the outdoors.
                </p>
                <p className="content">
                  <strong>Highlights:</strong> Wildlife jeep safari • Nature walks • Riverside time • Forest stay experience
                </p>
                <p className="content">
                  <strong>Best For:</strong> Families • Wildlife enthusiasts • Weekend travelers
                </p>
                <p className="content">
                  <strong>Experience Style:</strong> Balanced exploration with comfortable pacing and downtime
                </p>
                <p className='content'>Some forests reveal themselves slowly. Others arrive in a heartbeat.</p>
                <button className="primary_btn mt-4" onClick={openBooking}>Plan This Journey</button>
              </div>
            </div>
          </div>

          <div className="row g-0 align-items-start journey-row bg-color flex-md-row-reverse">
            <div className="col-md-6">
              <div className="">
                <img loading="lazy" decoding="async"
                  src={require("../../app/assets/images/Cycling.jpg.webp")}
                  alt="Forest Sampler"
                  className="journey-img"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="journey-content-box">
                <h2 className="heading">The Hornbill Experience</h2>
                <p className="sub-heading mb-4"><i>(3 nights & 4 days)</i></p>
                <p className="content">
                  <strong>Overview:</strong> A deeper journey into the forests of Uttarakhand with wildlife safari, village experiences, riverside activities, and slow nature-based living.<br />
                  Our most immersive retreat for guests who want to experience Camp Hornbill beyond a short escape.
                </p>
                <p className="content">
                  <strong>Highlights:</strong>  Wildlife jeep safari • Birdwatching • Cycling • Riverside activities • Village experiences • Local cooking session
                </p>
                <p className="content">
                  <strong>What to Wear:</strong> Muted colours, comfortable walking shoes, and season-appropriate outdoor clothing
                </p>
                <p className="content">
                  <strong>Best For:</strong> Families • Nature enthusiasts • Bird lovers • Slow travelers • Small groups
                </p>
                <p className="content">
                  <strong>Experience Style:</strong>  A relaxed yet immersive blend of exploration, learning, wildlife, and downtime
                </p>
                <p className="content">
                  <strong>Seasonal Forest Mood:</strong> Crisp winter mornings, shaded summer adventures, and lush monsoon landscapes throughout the year
                </p>
                <p className='content'>The longer you stay, the quieter the outside world becomes.</p>
                <button className="primary_btn mt-4" onClick={openBooking}>Plan This Journey</button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default FamilyRetreats
